import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'formly-field-button',
  template: `
    <div>
      <button type="button" [ngClass]="'btn btn-' + props.btnType + ' ' + props.className" (click)="onClick($event)" [disabled]="props.disabled" [tabIndex]="tabIndex">
        {{ props.text | translate }}
      </button>
    </div>
  `,
  imports: [TranslateModule, CommonModule],
})
export class FormlyFieldButtonComponent extends FieldType {

  constructor() {
    super();
  }

  onClick($event): void {
    $event.preventDefault();
    if (this.props.onClick) {
      this.props.onClick($event, this.form);
    }
  }

  public get tabIndex(): number {
    return this.props.tabindex || this.field.hide ? -1 : 0;
  }

}
